module.exports = __webpack_public_path__ + "static/media/famiglia.3aafd868.jpg";